import { render, staticRenderFns } from "./TextAnswer.vue?vue&type=template&id=0369b00a&scoped=true&"
import script from "./TextAnswer.vue?vue&type=script&lang=js&"
export * from "./TextAnswer.vue?vue&type=script&lang=js&"
import style0 from "./TextAnswer.vue?vue&type=style&index=0&id=0369b00a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0369b00a",
  null
  
)

export default component.exports